<template>
  <div class="page" :class="[scrollContent ? 'scroll-content' : '']">    
    <PageGallery @toggleImage="onToggleImage" :showImage="showAssetInfo" overlay>
    <template v-slot:page>
        <div ref="content">        
            <div class="all-content">    
                <div class="image">
                    <transition name="fade" mode="out-in" appear>
                        <vueVimeoPlayer
                            height="100%"
                            width="100%"
                            ref="player"
                            class="intro-video"
                            :controls=false                            
                            :options="{
                            autoplay:true,
                            }"        
                            :video-id="assets[currentAsset].video"
                            :style="videoStyle"
                        />
                    </transition>
                </div>                  
                  <div class="asset-info" v-if="currentAsset !== -1" :class="showAssetInfo ? 'show' : ''">                        
                        <p class="asset-name">Videos</p>
                        <div class="asset-items">
                            <button 
                                v-for="(asset, id) in assets"
                                @click="currentAsset = id;"
                                :key="id"
                                :class="[currentAsset === id ? 'active' : '']"
                            />
                        </div>
                        <div class='linear'>
                            <LinearButton dark back @click="goBack"></LinearButton>
                            <LinearButton dark @click="goForward"></LinearButton>
                        </div>
                    </div>       
            </div>
        </div>
    </template>
    </PageGallery>    
  </div>
</template>

<script>
import PageGallery from "@/patterns/PageGallery.vue";
import LinearButton from "@/patterns/LinearButton.vue";
import { vueVimeoPlayer } from "vue-vimeo-player";
export default {
  name: "LoadInPhotoGallery",
  components: {LinearButton, PageGallery, vueVimeoPlayer },
  data: () => ({
    scrollContent: false, 
    currentAsset:0,
    showAssetInfo:true,
    videoStyle: {},
    assets:[
        {
            display_name:"Intro Video",
            video:"564661128",
        },                
        {
            display_name:"Cost Savings",
            video:"542701148",
        },
    ]
  }),  
  mounted() {
    this.adjustVideo();
    window.addEventListener("resize", this.shouldScrollContent);
    window.addEventListener("resize", this.adjustVideo);    
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.shouldScrollContent);
    window.removeEventListener("resize", this.adjustVideo);
  },
  methods: {
    goBack() {
        this.currentAsset = this.currentAsset - 1;
        if(this.currentAsset < 0) {
            this.currentAsset = this.assets.length - 1;
        }
    },
    goForward() {
        this.currentAsset = this.currentAsset + 1;
        if(this.currentAsset == this.assets.length) {
            this.currentAsset = 0;
        }
    },
    venueSelected(id) {
        this.currentAsset = id;
        this.showAssetInfo = true; 
    },
    onToggleImage(showImage) {
        this.showAssetInfo = showImage;
    },
    shouldScrollContent() {
      this.scrollContent =
        this.$refs.content.clientHeight > window.innerHeight ? true : false;
    },
    adjustVideo() {
      let height = Math.max(480, window.innerHeight);
      let width = Math.max(800, window.innerWidth);
      let vw, vh;
      if (width / height > 16 / 9) {
        vw = Math.round(width);
        vh = Math.round((vw * 9) / 16);
      } else {
        vh = Math.round(height);
        vw = Math.round((vh * 16) / 9);
      }
      this.videoStyle = {
        width: vw + "px",
        height: vh + "px",
        left: (width - vw) / 2 + "px",
        right: (height - vh) / 2 + "px",
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.linear {
    position: relative;
    margin-top:60px;
}
.asset-info {
    position: absolute;
    left:60px;
    bottom:130px;
    transition: transform 0.25s cubic-bezier(1, 0.5, 0.8, 1);
    transform:translateY(calc(100% + 130px));
    .asset-name {
        color: #FFFFFF;
        font-family: 'Gotham';
        font-size: 2rem;
        font-weight: 900;
        letter-spacing: 0;
        line-height:1;
        text-transform:uppercase;
    }
    .asset-content {
        color: #FFF;
        font-family: 'Montserrat';
        font-size: 1rem;
        letter-spacing: 0;
        line-height: 1.7;
        max-width: 640px;
    }
    .asset-items {
        font-size: 0;
        margin-top:25px;
        button {
            cursor: pointer;
            width:40px;
            height:6px;
            background-color: #4B4B4D;
            border:none;
            outline:none;
            transition: background-color 0.25s cubic-bezier(1, 0.5, 0.8, 1);
            &:not(last-child) {
                margin-right:5px;
            }
            &.active {
                background-color: #fff;;
            }
        }
    }
    &.show {
        transition-delay: 0.2s;
        transform:translateY(0);
    }
}
.selector {    
    position: relative;    
    width: 100%;
}
.view-asset {  
  font-size: 0.8em;    
  margin-top:30px;
}
a {    
    color: #FFF;
    font-family: "Gotham";
    font-weight:bold;
    font-size: 0.8em;
    text-transform: uppercase;        
    text-decoration: none;
    img {
        margin-right:15px;
    }
    img, span {
        vertical-align: middle;
    }
}
</style>